require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./learning-learning-great-start-early-learning-centres.json") })
        }
      }, "path---learning-learning-great-start-early-learning-centres");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---learning-learning-great-start-early-learning-centres!./.cache/json/learning-learning-great-start-early-learning-centres.json
// module id = 1241
// module chunks = 231608221292675